import { AssetStatusBase } from './base/asset-status-base';

export class AssetStatus extends AssetStatusBase { }